var _ellipse, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect4, _rect5, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMaintain = function SvgMaintain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 160,
    viewBox: "0 0 300 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.5,
    cy: 143.5,
    rx: 55.5,
    ry: 12.5,
    fill: "#F9F9F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.4351,
    y: 51.5588,
    width: 8.24904,
    height: 51.2452,
    rx: 4.12452,
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237.168,
    y: 51.5588,
    width: 8.24904,
    height: 51.2452,
    rx: 4.12452,
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 26.1235,
    width: 241.853,
    height: 53.7452,
    rx: 8.06178,
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3084 27.467H92.1501L67.9648 78.525H45.123L69.3084 27.467Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.054 27.467H145.896L121.71 78.525H98.8687L123.054 27.467Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.455 27.467H198.297L174.112 78.525H151.27L175.455 27.467Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.857 27.467H250.699L226.514 78.525H203.672L227.857 27.467Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6369 26.1235L43.7798 79.8687",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1506 26.1235L67.2935 79.8687",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.127 26.1235L151.27 79.8687",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.641 26.1235L174.784 79.8687",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.383 26.1235L97.5254 79.8687",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.896 26.1235L121.039 79.8687",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.185 26.1235L202.328 79.8687",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M250.699 26.1235L225.842 79.8687",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9651 23.4363V19.4054C67.9651 14.2109 63.7542 10 58.5597 10C53.3652 10 49.1543 14.2109 49.1543 19.4054V23.4363C49.1543 24.9204 50.3574 26.1236 51.8416 26.1236H65.2779C66.762 26.1236 67.9651 24.9204 67.9651 23.4363Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250.699 23.4363V19.4054C250.699 14.2109 246.488 10 241.294 10C236.099 10 231.888 14.2109 231.888 19.4054V23.4363C231.888 24.9204 233.091 26.1236 234.575 26.1236H248.012C249.496 26.1236 250.699 24.9204 250.699 23.4363Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6865,
    y: 98.5857,
    width: 29.7471,
    height: 8.24904,
    rx: 2.78089,
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 226.42,
    y: 98.5857,
    width: 29.7471,
    height: 8.24904,
    rx: 2.78089,
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5908 16.7183C61.1438 15.7043 57.5057 14.2848 54.529 16.7183",
    stroke: "#777A7D",
    strokeWidth: 2.49333,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M245.325 16.7183C243.878 15.7043 240.24 14.2848 237.263 16.7183",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150.565 149.26C158.477 149.26 156.09 130.46 156.09 130.46C165.54 148.295 172.14 149.26 174.577 145.801C176.14 143.645 175.827 141.213 173.69 138.469C171.552 135.724 165.34 128.091 165.34 128.091C182.84 142.78 185.415 133.631 185.727 131.011C186.04 128.392 180.64 126.161 174.315 123.617C167.402 120.884 169.315 117.726 169.315 117.726C193.44 90.0648 171.89 71.3525 150.565 71.3525C129.24 71.3525 107.702 90.0648 131.815 117.726C131.815 117.726 133.777 120.884 126.815 123.617C120.427 126.123 115.027 128.354 115.34 130.986C115.652 133.618 118.327 142.755 135.79 128.091C135.79 128.091 129.54 135.824 127.44 138.556C125.34 141.289 124.577 144.196 126.552 145.888C130.477 149.285 136.877 147.053 145.04 130.547C145.002 130.133 142.652 149.26 150.565 149.26Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150.565 105.468C148.827 105.468 147.615 107.435 147.615 110.243C147.615 113.05 148.865 115.018 150.565 115.018C152.265 115.018 153.515 113.05 153.515 110.243C153.515 107.435 152.302 105.468 150.565 105.468ZM150.565 100.68C154.827 100.68 158.277 104.954 158.277 110.243C158.277 115.532 154.827 119.806 150.565 119.806C146.302 119.806 142.852 115.519 142.852 110.243C142.852 104.966 146.302 100.68 150.565 100.68Z",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.34 93.761C135.805 93.761 135.283 93.9201 134.838 94.2181C134.394 94.5162 134.048 94.9397 133.844 95.4351C133.64 95.9305 133.587 96.4755 133.692 97.001C133.798 97.5265 134.056 98.0088 134.435 98.3869C134.814 98.765 135.296 99.0219 135.821 99.1249C136.345 99.2279 136.888 99.1725 137.382 98.9657C137.875 98.7589 138.296 98.41 138.591 97.9631C138.886 97.5163 139.042 96.9916 139.04 96.4557C139.043 96.0998 138.975 95.7469 138.841 95.4176C138.706 95.0883 138.507 94.7893 138.256 94.5383C138.004 94.2872 137.705 94.0891 137.376 93.9556C137.047 93.8222 136.695 93.756 136.34 93.761Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M164.79 93.762C164.255 93.7595 163.731 93.9165 163.285 94.213C162.839 94.5095 162.491 94.9322 162.285 95.4274C162.079 95.9226 162.025 96.4679 162.128 96.9942C162.232 97.5206 162.49 98.0041 162.868 98.3834C163.246 98.7628 163.729 99.0209 164.253 99.125C164.778 99.229 165.322 99.1743 165.816 98.9679C166.31 98.7614 166.732 98.4125 167.027 97.9654C167.323 97.5183 167.48 96.9931 167.477 96.4567C167.479 96.1023 167.41 95.7512 167.276 95.4235C167.141 95.0958 166.944 94.7981 166.694 94.5475C166.444 94.297 166.147 94.0986 165.82 93.9637C165.493 93.8289 165.143 93.7603 164.79 93.762Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M217.815 122.439C205.379 85.6979 170.601 88.3572 170.601 88.3572C170.601 88.3572 198.125 93.5802 217.815 122.439Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204.506 89.4826L204.47 89.4585C203.507 88.8083 202.142 89.1509 201.422 90.2237L175.957 128.177C175.237 129.25 175.435 130.646 176.399 131.297L176.435 131.321C177.399 131.971 178.764 131.628 179.484 130.555L204.948 92.6023C205.668 91.5295 205.47 90.1328 204.506 89.4826Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M203.742 95.8475L198.819 92.5262C198.051 92.0088 197.011 92.2128 196.495 92.9819L190.99 101.187C190.474 101.956 190.678 102.999 191.445 103.516L196.369 106.837C197.136 107.355 198.176 107.151 198.692 106.382L204.197 98.1768C204.713 97.4077 204.509 96.3649 203.742 95.8475Z",
    fill: "white",
    stroke: "#777A7D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaintain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maintain.b6acf384.svg";
export { ForwardRef as ReactComponent };